import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=79d870c3&scoped=true&lang=pug&"
var script = {}
import style0 from "./cmp.vue?vue&type=style&index=0&id=79d870c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d870c3",
  null
  
)

export default component.exports